import store from '@state/store';
import lazyLoadView from './lazy-load-view';

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('views/home')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          if (store.getters['user/onboardingComplete']) {
            next({ name: 'embed', params: { ...routeTo.query }, query: { ...routeTo.query } });
          } else {
            next({ name: 'onboarding', params: { ...routeTo.query } });
          }
        } else {
          next({ name: 'login' });
        }
      },
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'embed' }); // Redirect to the embed route
        } else if (routeTo.query.embed) {
          next({ name: '401' }); // Redirect to the 401 route
        } else {
          next(); // Continue to the login page
        }
      },
    },
  },
  {
    path: '/sign-up',
    name: 'signup',
    component: () => lazyLoadView(import('views/signup')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'embed' }); // Redirect to the embed route
        } else if (routeTo.query.embed) {
          next({ name: '401' }); // Redirect to the 401 route
        } else {
          next(); // Continue to the login page
        }
      },
    },
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => lazyLoadView(import('views/onboarding')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/loggedIn']) {
          next({ name: 'login' });
        } else if (routeTo.query.embed) {
          next({ name: '401' });
        } else {
          await store.dispatch('user/getUserProfile').then((res) => {
            const onboardingEnabled = store.state.onboarding.isOnboardingEnabled;
            const urlParams = Object.keys(routeTo.params).length ? { ...routeTo.params } : { ...routeTo.query };
            !onboardingEnabled || res.onboardingComplete ? next({ name: 'embed', params: urlParams }) : next();
          });
        }
      },
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => lazyLoadView(import('views/reset-password')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'embed' }); // Redirect to the embed route
        } else if (routeTo.query.embed) {
          next({ name: '401' }); // Redirect to the 401 route
        } else {
          next(); // Continue to the login page
        }
      },
    },
  },
  {
    path: '/plan',
    name: 'plan',
    component: () => lazyLoadView(import('views/plan')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ isEmbed: false, user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('views/profile')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => lazyLoadView(import('views/logout')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.getters['auth/loggedIn'] ? store.dispatch('auth/logOut') && next() : next({ name: 'login' });
      },
    },
  },
  {
    path: '/embed',
    name: 'embed',
    component: () => lazyLoadView(import('views/embed')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ isEmbed: true, user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/public',
    name: 'public',
    component: () => lazyLoadView(import('views/embedPublic')),
    props: (route) => ({ isEmbed: true, user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/404',
    name: '404',
    component: require('views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/401',
    name: '401',
    component: require('views/_401').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
];
